import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaGoogle, FaMicrosoft } from "react-icons/fa";
import logo3 from "../assets/images/logo3.png";
import { Link, useNavigate } from "react-router-dom";
import { EcomAPI,CMSAPI } from "../config";
import axios from "axios";
import { getCookie } from "../utils/cookies";
import { setCookie } from "../utils/cookies";
import toast from "react-hot-toast";
import { FaTimes } from "react-icons/fa";

const SignIn = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    agreeTerms: false,
  });
  const [formErrors, setFormErrors] = useState({
    email: false,
    password: false,
    agreeTerms: false,
  });
  const [apiError, setApiError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    // Clear errors when user types
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: false,
      });
    }
    if (apiError) setApiError(null);
  };

  const validateForm = () => {
    const value = formData.email.trim();
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    const isPhone = /^[0-9]{10}$/.test(value);

    const errors = {
      email: !(isEmail || isPhone),
      password: !formData.password,
      agreeTerms: !formData.agreeTerms,
    };

    setFormErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError(null);

    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const response = await axios.get(
        `${CMSAPI}/api/Website/login-customer?email=${encodeURIComponent(
          formData.email
        )}&password=${encodeURIComponent(formData.password)}`
      );

      const data = response.data;

      if (data && data.id) {
        // Set cookies with proper expiration
        const expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + 24 * 60 * 60 * 1000); // 1 day
        const expires = expiryDate.toUTCString();

        document.cookie = `auth=true; expires=${expires}; path=/`;
        document.cookie = `userName=${encodeURIComponent(
          formData.email
        )}; expires=${expires}; path=/`;
        document.cookie = `email=${encodeURIComponent(
          formData.email
        )}; expires=${expires}; path=/`;
        document.cookie = `userId=${data.id}; expires=${expires}; path=/`;
        // Inside SignIn's handleSubmit
        document.cookie = `isLoggedIn=true; expires=${expires}; path=/`;

        // const expiry = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
        // document.cookie = `userName=${encodeURIComponent(formData.email)}; expires=${expiry}; path=/`;
        // document.cookie = `email=${encodeURIComponent(formData.email)}; expires=${expiry}; path=/`;
        // document.cookie = `isLoggedIn=true; expires=${expiry}; path=/`;
        // document.cookie = `userId=${data.id}; expires=${expiry}; path=/`;

        // MIGRATE GUEST CART ITEMS
        const guestCart = JSON.parse(getCookie("guestCart") || "[]");
        if (guestCart.length > 0) {
          try {
            // Add each guest cart item to user's cart
            for (const productId of guestCart) {
              const payload = {
                id: 0,
                productId: productId,
                userId: data.id,
              };
              await axios.post(`${CMSAPI}/api/Website/add-to-cart`, payload, {
                headers: { "Content-Type": "application/json" },
              });
            }

            // Clear guest cart after successful migration
            setCookie("guestCart", JSON.stringify([]), 86400, "/");

            // Notify user about migration
            toast.success(`${guestCart.length} item(s) moved to your cart!`);
          } catch (migError) {
            console.error("Cart migration failed:", migError);
            toast.error("Failed to migrate some cart items");
          }
        }

        // Redirect to cart page
        navigate("/cart");
      } else {
        throw new Error("Login failed: No valid response received.");
      }
    } catch (error) {
      console.error("Login error:", error);
      let errorMessage = "Login failed";

      if (error.response) {
        // Server responded with error status
        errorMessage = error.response.data?.message || "Invalid credentials";
      } else if (error.request) {
        // No response received
        errorMessage = "No response from server. Please try again.";
      } else {
        // Other errors
        errorMessage = error.message || "Login failed";
      }

      setApiError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Modal component to avoid code duplication
  const Modal = ({ title, children, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center">
          <h2 className="text-2xl font-bold text-[#00D084]">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <FaTimes className="text-2xl" />
          </button>
        </div>
        <div className="p-6">{children}</div>
        <div className="sticky bottom-0 bg-white p-4 border-t flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#00D084] text-white rounded hover:bg-green-600"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      {/* pp */}
      {/* Privacy Policy Modal */}
      {showPrivacyModal && (
        <Modal
          title="Privacy Policy"
          onClose={() => setShowPrivacyModal(false)}
        >
          <div className="w-full px-4 sm:px-6 md:px-10 lg:px-0 py-10 bg-white text-gray-800 text-justify">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
  {/* Privacy Policy content */}
 <div className="mb-10">
  <h1 className="text-3xl font-bold text-black mb-2">
    Privacy Policy - GyanYantram Management System
  </h1>
  <p className="text-lg text-black mb-4">
    <strong>Effective Date:</strong> 17-06-2025
    <br />
    <strong>Platform Name:</strong> GyanYantram
    <br />
    <strong>Operated by:</strong> Ajeevi Technologies Pvt. Ltd.
    <br />
    <strong>Location:</strong> Noida, Uttar Pradesh, India
  </p>
</div>

{/* Introduction Section */}
<div className="mb-10">
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">1. Introduction</h4>
  <p className="text-black mb-4 text-lg">
    Ajeevi Technologies Pvt. Ltd. ("Ajeevi", "we", "us", or "our") operates the GyanYantram platform, 
    a smart city management system that integrates services such as water supply, waste management, 
    mobility, parking, energy, sanitation, and public grievance redressal.
  </p>
  <p className="text-black text-lg">
    This Privacy Policy explains how we collect, use, and protect your information while using 
    the GyanYantram platform through mobile apps, dashboards, and municipal interfaces, 
    in compliance with the Digital Personal Data Protection Act, 2023.
  </p>
</div>

{/* Scope of Application */}
<div className="mb-10">
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">2. Scope of Application</h4>
  <p className="text-black mb-4 text-lg">
    This policy applies to all digital services offered under GyanYantram, including:
  </p>
  <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
    <li>GyanYantram mobile applications</li>
    <li>Smart city monitoring dashboards</li>
    <li>Public grievance systems</li>
    <li>Utility billing and analytics modules</li>
    <li>Environmental and mobility data interfaces</li>
  </ul>
</div>

{/* Types of Information We Collect */}
<div className="mb-10">
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">3. Data We Collect</h4>

  <h5 className="text-xl font-semibold mb-3 text-black">3.1 Personal and User Information</h5>
  <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
    <li>User registration data (name, email, phone)</li>
    <li>Geolocation (if using navigation or public service mapping)</li>
    <li>Complaint or feedback history</li>
    <li>Utility account details (if integrated)</li>
  </ul>

  <h5 className="text-xl font-semibold mb-3 text-black">3.2 Platform Usage Data</h5>
  <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
    <li>Module accessed (grievance, sanitation, water, etc.)</li>
    <li>Time and duration of sessions</li>
    <li>Interaction with public dashboards or services</li>
  </ul>

  <h5 className="text-xl font-semibold mb-3 text-black">3.3 Device and Technical Info</h5>
  <ul className="list-disc pl-6 space-y-2 text-lg text-black">
    <li>Device type and operating system</li>
    <li>Browser type and version</li>
    <li>IP address and network details</li>
  </ul>
</div>

{/* How We Use Your Data */}
<div className="mb-10">
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">4. Purpose of Data Processing</h4>
  <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
    <li>To improve citizen experience and service delivery</li>
    <li>To enable smart analytics for government use</li>
    <li>To maintain logs for service usage and feedback</li>
    <li>To process utility transactions and user interactions</li>
    <li>To ensure security and platform stability</li>
  </ul>
</div>

{/* Data Sharing */}
<div className="mb-10">
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">5. Data Sharing</h4>
  <p className="text-black mb-4 text-lg">
    We may share limited data with:
  </p>
  <ul className="list-disc pl-6 space-y-2 text-lg text-black">
    <li>Municipal authorities for service coordination</li>
    <li>Government departments for planning and analysis</li>
    <li>Law enforcement if required by legal order</li>
  </ul>
  <p className="text-black text-lg mt-4">
    We do not sell or monetize personal data under any circumstances.
  </p>
</div>

{/* Data Security */}
<div className="mb-10">
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">6. Security Measures</h4>
  <ul className="list-disc pl-6 space-y-2 text-lg text-black">
    <li>Encrypted storage of sensitive user data</li>
    <li>Secure role-based access control</li>
    <li>Routine vulnerability and security checks</li>
    <li>Data backup and recovery systems</li>
  </ul>
</div>

{/* Data Retention */}
<div className="mb-10">
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">7. Data Retention</h4>
  <div className="overflow-x-auto">
    <table className="min-w-full border border-gray-200 text-lg">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-4 py-2 border border-gray-200">Data Type</th>
          <th className="px-4 py-2 border border-gray-200">Retention Period</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="px-4 py-2 border border-gray-200">User Profile Data</td>
          <td className="px-4 py-2 border border-gray-200">Until account is deleted</td>
        </tr>
        <tr>
          <td className="px-4 py-2 border border-gray-200">Grievance & Service Logs</td>
          <td className="px-4 py-2 border border-gray-200">5 years</td>
        </tr>
        <tr>
          <td className="px-4 py-2 border border-gray-200">Payment Data (if any)</td>
          <td className="px-4 py-2 border border-gray-200">7 years (per financial norms)</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

{/* User Rights */}
<div className="mb-10">
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">8. Your Rights</h4>
  <ul className="list-disc pl-6 space-y-2 text-lg text-black">
    <li>Right to view your personal data</li>
    <li>Right to correct inaccurate information</li>
    <li>Right to request data deletion (subject to legal constraints)</li>
    <li>Right to raise grievances or feedback</li>
  </ul>
</div>

{/* Contact Information */}
<div>
  <h4 className="text-[#00D084] text-2xl font-semibold mb-3">9. Contact Us</h4>
  <p className="text-black text-lg mb-2">
    <strong>Ajeevi Technologies Pvt. Ltd.</strong>
    <br />
    505, Advant Navis Business Park, Tower A-1
    <br />
    Sector 142, Noida, Uttar Pradesh – 201301
  </p>
  <p className="text-black text-lg">
    📧 <a href="mailto:support@ajeevi.com" className="text-[#00D084]">support@ajeevi.com</a>
    <br />
    📞 <a href="tel:+919654325300" className="text-[#00D084]">+91-9654325300</a>
  </p>
  <p className="text-black text-lg mt-4">
    Note: This Privacy Policy may be modified to reflect future updates in GyanYantram services or legal changes.
  </p>
  </div>
  </div>

          </div>
        </Modal>
      )}
      {/* pp */}

      {/* TOU */}
      {/* Terms of Use Modal */}
      {showTermsModal && (
        // <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
        //   <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        //     <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center">
        //       <h2 className="text-2xl font-bold text-[#00D084]">
        //         Terms of Use
        //       </h2>
        //       <button
        //         onClick={() => setShowTermsModal(false)}
        //         className="text-gray-500 hover:text-gray-700"
        //       >
        //         <FaTimes className="text-2xl" />
        //       </button>
        //     </div>
        //     <div className="p-6">
        //       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-0 py-10 bg-white text-gray-800 text-justify">
        //         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        //           {/* Header Section */}
        //           <div className="mb-10">
        //             <h1 className="text-3xl font-bold text-black mb-2">
        //               Terms of Use - GyanYantram Management System
        //             </h1>
        //             <p className="text-lg text-black mb-4">
        //               <strong>Effective Date:</strong> 17-06-2025
        //               <br />
        //               <strong>Platform:</strong> ParkAJV
        //               <br />
        //               <strong>Operated By:</strong> Ajeevi Technologies Pvt.
        //               Ltd.
        //             </p>
        //           </div>

        //           {/* Welcome Statement */}
        //           <div className="mb-10">
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               Welcome Statement
        //             </h4>
        //             <p className="text-black mb-4 text-lg">
        //               Welcome to ParkAJV, an AI-powered parking management
        //               platform developed and maintained by Ajeevi Technologies
        //               Pvt. Ltd. This system enables smart parking solutions
        //               through real-time space monitoring, automated enforcement,
        //               digital payments, and data-driven urban planning.
        //             </p>
        //             <p className="text-black text-lg">
        //               These Terms govern your access to and use of this GyanYantram
        //               management platform, including all associated services,
        //               mobile apps, and interfaces. By using this platform, you
        //               agree to be legally bound by these terms and all
        //               applicable laws and regulations.
        //             </p>
        //           </div>

        //           {/* Purpose of the Platform */}
        //           <div className="mb-10">
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               1. Purpose of the Platform
        //             </h4>
        //             <p className="text-black mb-4 text-lg">
        //               The ParkAJV platform serves as a comprehensive parking
        //               ecosystem designed to:
        //             </p>
        //             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        //               <li>
        //                 Enable real-time parking space availability monitoring
        //                 and guidance
        //               </li>
        //               <li>
        //                 Automate parking violation detection and enforcement
        //               </li>
        //               <li>
        //                 Facilitate seamless digital payments and permit
        //                 management
        //               </li>
        //               <li>
        //                 Provide data analytics for urban planning and traffic
        //                 management
        //               </li>
        //               <li>
        //                 Enhance citizen experience through mobile parking
        //                 solutions
        //               </li>
        //               <li>
        //                 Support smart city initiatives and sustainable mobility
        //                 goals
        //               </li>
        //             </ul>
        //           </div>

        //           {/* Eligibility and Access */}
        //           <div className="mb-10">
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               2. Eligibility and Access
        //             </h4>
        //             <h5 className="text-xl font-semibold mb-3 text-black">
        //               2.1 Authorized Users
        //             </h5>
        //             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        //               <li>
        //                 Motor vehicle owners/operators within service areas
        //               </li>
        //               <li>Municipal parking enforcement officers</li>
        //               <li>Authorized parking facility operators</li>
        //               <li>Urban planners and traffic management authorities</li>
        //             </ul>

        //             <h5 className="text-xl font-semibold mb-3 text-black">
        //               2.2 Restricted Users
        //             </h5>
        //             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        //               <li>Individuals with suspended parking privileges</li>
        //               <li>Unauthorized commercial parking operators</li>
        //               <li>Automated systems/bots not explicitly permitted</li>
        //             </ul>
        //           </div>

        //           {/* User Responsibilities */}
        //           <div className="mb-10">
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               3. User Responsibilities
        //             </h4>
        //             <h5 className="text-xl font-semibold mb-3 text-black">
        //               3.1 Accurate Information
        //             </h5>
        //             <p className="text-black mb-4 text-lg">
        //               Users must ensure all vehicle information, payment
        //               details, and permit applications are accurate and current.
        //             </p>

        //             <h5 className="text-xl font-semibold mb-3 text-black">
        //               3.2 Parking Compliance
        //             </h5>
        //             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        //               <li>
        //                 Adhere to all posted parking regulations and time limits
        //               </li>
        //               <li>Only use designated parking spaces appropriately</li>
        //               <li>Ensure proper payment for parking sessions</li>
        //             </ul>

        //             <h5 className="text-xl font-semibold mb-3 text-black">
        //               3.3 Account Security
        //             </h5>
        //             <p className="text-black mb-4 text-lg">
        //               Users are responsible for maintaining the confidentiality
        //               of login credentials and all activities conducted through
        //               their accounts.
        //             </p>
        //           </div>

        //           {/* System Functionality */}
        //           <div className="mb-10">
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               4. System Functionality
        //             </h4>
        //             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        //               <li>
        //                 ANPR cameras may capture vehicle details for enforcement
        //                 purposes
        //               </li>
        //               <li>
        //                 Real-time availability data is approximate and subject
        //                 to change
        //               </li>
        //               <li>
        //                 Payment processing times may vary by financial
        //                 institution
        //               </li>
        //             </ul>
        //           </div>

        //           {/* Data Collection */}
        //           <div className="mb-10">
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               5. Data Collection
        //             </h4>
        //             <p className="text-black mb-4 text-lg">We collect:</p>
        //             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        //               <li>Vehicle registration details</li>
        //               <li>
        //                 Parking session data (location, duration, payment)
        //               </li>
        //               <li>Enforcement records (violations, appeals)</li>
        //               <li>Usage patterns for service improvement</li>
        //             </ul>
        //           </div>

        //           {/* Payment Terms */}
        //           <div className="mb-10">
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               6. Payment Terms
        //             </h4>
        //             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        //               <li>All parking fees are non-refundable</li>
        //               <li>
        //                 Unpaid violations may result in additional penalties
        //               </li>
        //               <li>
        //                 The platform supports authorized payment methods only
        //               </li>
        //             </ul>
        //           </div>

        //           {/* Enforcement */}
        //           <div className="mb-10">
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               7. Parking Enforcement
        //             </h4>
        //             <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
        //               <li>
        //                 Violations are documented via ANPR and officer
        //                 verification
        //               </li>
        //               <li>Appeals must be submitted within 7 business days</li>
        //               <li>
        //                 Repeated violations may lead to account suspension
        //               </li>
        //             </ul>
        //           </div>

        //           {/* Contact Information */}
        //           <div>
        //             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        //               Contact Information
        //             </h4>
        //             <p className="text-black mb-4 text-lg">
        //               For parking inquiries or technical support:
        //             </p>
        //             <p className="text-black text-lg mb-2">
        //               <strong>Ajeevi Technologies Pvt. Ltd.</strong>
        //               <br />
        //               505, Advant Navis Business Park, Tower A-1
        //               <br />
        //               Sector 142, Noida, Uttar Pradesh – 201301
        //             </p>
        //             <p className="text-black text-lg">
        //               📧{" "}
        //               <a
        //                 href="mailto:parking@ajeevi.com"
        //                 className="text-[#00D084]"
        //               >
        //                 parking@ajeevi.com
        //               </a>
        //               <br />
        //               📞{" "}
        //               <a href="tel:+919654325300" className="text-[#00D084]">
        //                 +91-9654323500
        //               </a>
        //             </p>

        //             <p>
        //               Note: Terms & Conditions is subjected to changed anytime.
        //             </p>
        //           </div>
        //         </div>
        //       </div>
        //     </div>
        //     <div className="sticky bottom-0 bg-white p-4 border-t flex justify-end">
        //       <button
        //         onClick={() => setShowTermsModal(false)}
        //         className="px-4 py-2 bg-[#00D084] text-white rounded hover:bg-green-600"
        //       >
        //         Close
        //       </button>
        //     </div>
        //   </div>
        // </div>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
  <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
    <div className="sticky top-0 bg-white p-4 border-b flex justify-between items-center">
      <h2 className="text-2xl font-bold text-[#00D084]">Terms of Use</h2>
      <button
        onClick={() => setShowTermsModal(false)}
        className="text-gray-500 hover:text-gray-700"
      >
        <FaTimes className="text-2xl" />
      </button>
    </div>
    <div className="p-6">
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-0 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header Section */}
          <div className="mb-10">
            <h1 className="text-3xl font-bold text-black mb-2">
              Terms of Use – GyanYantram Smart-City Platform
            </h1>
            <p className="text-lg text-black mb-4">
              <strong>Effective Date:</strong> 17-06-2025
              <br />
              <strong>Platform:</strong> GyanYantram by Ajeevi Technologies Pvt. Ltd.
              <br />
              <strong>Operated By:</strong> Ajeevi Technologies Pvt. Ltd.
            </p>
          </div>

          {/* Welcome Statement */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Welcome Statement
            </h4>
            <p className="text-black mb-4 text-lg">
              Welcome to GyanYantram, a smart-city platform developed by Ajeevi Technologies Pvt. Ltd. 
              GyanYantram enables real-time monitoring and intelligent management of urban services such as 
              water, waste, energy, sanitation, mobility, transport, and public safety.
            </p>
            <p className="text-black text-lg">
              These Terms govern your access to and use of this platform, including any associated mobile apps,
              services, and interfaces. By using GyanYantram, you agree to these Terms and all applicable laws.
            </p>
          </div>

          {/* Purpose of the Platform */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              1. Purpose of the Platform
            </h4>
            <p className="text-black mb-4 text-lg">
              GyanYantram serves as an integrated urban infrastructure platform to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Monitor city utilities and assets in real-time</li>
              <li>Enable smart governance and service automation</li>
              <li>Facilitate digital payments for municipal services</li>
              <li>Provide analytics for informed urban planning</li>
              <li>Support public grievance and resolution systems</li>
              <li>Enhance citizen engagement and convenience</li>
            </ul>
          </div>

          {/* Eligibility and Access */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              2. Eligibility and Access
            </h4>
            <h5 className="text-xl font-semibold mb-3 text-black">2.1 Authorized Users</h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Registered municipal users and administrators</li>
              <li>Utility and service operators</li>
              <li>Citizens using GyanYantram for city services</li>
              <li>Partner agencies and government departments</li>
            </ul>

            <h5 className="text-xl font-semibold mb-3 text-black">2.2 Restricted Users</h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Unauthorized bots or automated systems</li>
              <li>Impersonators or banned individuals</li>
              <li>Entities attempting misuse or data scraping</li>
            </ul>
          </div>

          {/* User Responsibilities */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              3. User Responsibilities
            </h4>
            <h5 className="text-xl font-semibold mb-3 text-black">3.1 Accuracy of Information</h5>
            <p className="text-black mb-4 text-lg">
              Users must provide correct and up-to-date information related to profiles, services, and complaints.
            </p>

            <h5 className="text-xl font-semibold mb-3 text-black">3.2 Proper Usage</h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Use services responsibly and only for authorized purposes</li>
              <li>Follow all applicable local rules and city policies</li>
              <li>Do not misuse features for spamming or fraudulent activities</li>
            </ul>

            <h5 className="text-xl font-semibold mb-3 text-black">3.3 Account Security</h5>
            <p className="text-black mb-4 text-lg">
              Maintain confidentiality of your account login and immediately report any unauthorized access.
            </p>
          </div>

          {/* Platform Features and Limitations */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              4. Platform Features and Limitations
            </h4>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Real-time data may vary based on network conditions</li>
              <li>Service availability may depend on your city or zone</li>
              <li>Response time to grievances may vary</li>
              <li>Platform updates may occur without prior notice</li>
            </ul>
          </div>

          {/* Data Collection */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              5. Data Collection
            </h4>
            <p className="text-black mb-4 text-lg">GyanYantram may collect:</p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>User profile and login activity</li>
              <li>Service usage patterns and complaint history</li>
              <li>Sensor data from IoT devices (e.g., water, flood, environment)</li>
              <li>Payment and transaction records</li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Contact Information
            </h4>
            <p className="text-black mb-4 text-lg">
              For support or platform-related queries:
            </p>
            <p className="text-black text-lg mb-2">
              <strong>Ajeevi Technologies Pvt. Ltd.</strong>
              <br />
              505, Advant Navis Business Park, Tower A-1
              <br />
              Sector 142, Noida, Uttar Pradesh – 201301
            </p>
            <p className="text-black text-lg">
              📧{" "}
              <a href="mailto:support@ajeevi.com" className="text-[#00D084]">
                support@ajeevi.com
              </a>
              <br />
              📞{" "}
              <a href="tel:+919654325300" className="text-[#00D084]">
                +91-9654325300
              </a>
            </p>

            <p className="text-sm mt-4">
              Note: Terms & Conditions are subject to change without prior notice.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className="sticky bottom-0 bg-white p-4 border-t flex justify-end">
      <button
        onClick={() => setShowTermsModal(false)}
        className="px-4 py-2 bg-[#00D084] text-white rounded hover:bg-green-600"
      >
        Close
      </button>
    </div>
  </div>
</div>

      )}
      {/* TOU */}

      <div className="w-full max-w-4xl bg-white rounded-lg shadow-md overflow-hidden">
        <FaTimes
          className="text-gray-500 cursor-pointer text-2xl ml-auto mt-1 mr-1"
          onClick={() => navigate("/")}
        />
        <div className="flex flex-col md:flex-row">
          {/* Left Section */}
          <div className="hidden md:flex md:w-1/2 bg-white flex-col justify-center items-center p-8 text-center">
            <img
              src={logo3}
              alt="SwachhAjv Logo"
              className="max-w-[150px] mb-4"
            />
          <h5 className="font-bold text-lg">
  Welcome to GyanYantram Management System
</h5>
<p className="text-gray-500 text-md mt-2">
  AI-powered GyanYantram management with real-time monitoring, automated controls, 
  and urban analytics. Access your centralized infrastructure command center.
</p>

            <Link
              to="/"
              className="mt-4 px-2 py-1 border border-[#00D084] text-[#00D084] rounded-lg text-md hover:bg-[#00D084] hover:text-white transition-colors"
            >
              Go to Home
            </Link>
          </div>

          {/* Right Section */}
          <div className="w-full md:w-1/2 p-6 md:p-8">
            <div className="text-center mb-6">
              <h5 className="font-bold text-[#00D084] mb-1 text-xl">Sign In</h5>
              <p className="text-gray-500 text-md">
                Access your GyanYantram dashboard
              </p>
            </div>

            {/* API Error Message */}
            {apiError && (
              <div className="mb-4 p-3 bg-red-50 border-l-4 border-red-500 text-red-700 rounded">
                <div className="flex items-center">
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="font-medium">Error:</span>
                </div>
                <p className="mt-1 text-sm">{apiError}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4" noValidate>
              {/* Email */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-md text-gray-600 mb-1"
                >
                  Email or Mobile
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className={`w-full px-3 py-2 border rounded-md text-sm ${
                    formErrors.email ? "border-red-500" : "border-gray-300"
                  }`}
                  placeholder="Enter your email or mobile number"
                  required
                />
                {formErrors.email && (
                  <p className="text-red-500 text-xs mt-1">
                    Please enter a valid email or 10-digit mobile number.
                  </p>
                )}
              </div>

              {/* Password */}
              <div>
                <label
                  htmlFor="password"
                  className="block text-md text-gray-600 mb-1"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2 border rounded-md text-sm ${
                      formErrors.password ? "border-red-500" : "border-gray-300"
                    }`}
                    placeholder="Enter your Password"
                    required
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {formErrors.password && (
                  <p className="text-red-500 text-xs mt-1">
                    Password is required.
                  </p>
                )}
              </div>

              {/* Forgot Password */}
              <div className="flex justify-end">
                {/* <Link 
                  to="/forgot-password" 
                  className="text-md text-[#00D084] hover:underline"
                >
                  Forgot password?
                </Link> */}
              </div>

              {/* Terms Agreement */}
              <div className="flex items-start">
                <input
                  type="checkbox"
                  id="agreeTerms"
                  name="agreeTerms"
                  checked={formData.agreeTerms}
                  onChange={handleInputChange}
                  className="mt-1 mr-2"
                  required
                />
                <label htmlFor="agreeTerms" className="text-sm text-gray-600">
                  By continuing, I agree to the{" "}
                  <button
                    type="button"
                    onClick={() => setShowTermsModal(true)}
                    className="text-[#00D084] font-semibold hover:underline"
                  >
                    Terms of Use
                  </button>{" "}
                  &{" "}
                  <button
                    type="button"
                    onClick={() => setShowPrivacyModal(true)}
                    className="text-red-500 font-semibold hover:underline"
                  >
                    Privacy Policy
                  </button>{" "}
                  and I am above 18 years old.
                </label>
                {formErrors.agreeTerms && (
                  <p className="text-red-500 text-xs mt-1">
                    You must agree to the terms.
                  </p>
                )}
              </div>

              {/* Sign In Button */}
              <button
                type="submit"
                className="w-full bg-[#00D084] text-white py-2 rounded-md hover:bg-green-600 transition-colors disabled:opacity-50"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center">
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Signing In...
                  </span>
                ) : (
                  "Sign In"
                )}
              </button>

              {/* OR Divider */}
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300"></div>
                </div>
                <div className="relative flex justify-center">
                  <span className="bg-white px-2 text-sm text-gray-500">
                    OR
                  </span>
                </div>
              </div>

              {/* Social Buttons */}
              {/* <div className="flex gap-3">
                <button
                  type="button"
                  className="flex-1 flex items-center justify-center gap-2 border border-red-500 text-red-500 py-2 rounded-md hover:bg-red-50 transition-colors text-sm"
                >
                  <FaGoogle /> Google
                </button>
                <button
                  type="button"
                  className="flex-1 flex items-center justify-center gap-2 border border-blue-500 text-blue-500 py-2 rounded-md hover:bg-blue-50 transition-colors text-sm"
                >
                  <FaMicrosoft /> Microsoft
                </button>
              </div> */}

              {/* Create Account */}
              <div className="text-center text-sm">
                Don't have an account?{" "}
                <Link
                  to="/register"
                  className="text-[#00D084] font-medium hover:underline"
                >
                  Create an account
                </Link>
              </div>

              {/* Get Help */}
              {/* <div className="text-center text-sm mt-2">
                Have trouble logging in?{' '}
                <Link to="/help" className="text-red-500 font-medium hover:underline">
                  Get help
                </Link>
              </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
